<app-unenrollment-confirm-modal
  *ngIf="confirmModal"
  (closeModal)="closeUnenrollModal()"
  [policyNumber]="onRemovePolicy.policynumber.policyNumber"
  [where]="where"
></app-unenrollment-confirm-modal>

<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <ng-container *ngIf="checkForEligibility">
    <ng-container>
        <div class="manage-paperless-header-title" [ngClass]="{'margin-left-24 col':!isAcmic}">
          {{ 'MANAGE_PAPERLESS' | translate }}
        </div>
    </ng-container>

    <div
      class="row margin-top paperlessInfo paperless-time-container margin-left-24 flex-column"
    >
      <ng-container>
        <div class="col" [ngClass]="{ 'paperless-padding': isAcmic, 'paperless-padding-ma':!isAcmic }">
          <p
            class="manage-paperless-header-sub-title" [ngClass]="{'margin-bottom mb-2':isAcmic, 'margin-bottom mb-3':!isAcmic}"
          >
            {{ 'HELP_US_STAY_GREEN_LOWCASE' | translate }}
            {{ 'ENROLL_IN_OUR_PAPERLESS_PROGRAM_TODAY' | translate }}
          </p>

          <div class="margin-bottom mb24 lh-0 vector" *ngIf="isAcmic">
            <svg xmlns="http://www.w3.org/2000/svg" width="842" height="1" viewBox="0 0 842 1" fill="none" style="display: block; width: 100%;">
              <path d="M0 0.5H842" stroke="#CCCCCC" />
            </svg>
          </div>
          <div class="margin-bottom mb24 lh-0 vector" *ngIf="!isAcmic">
            <svg xmlns="http://www.w3.org/2000/svg" width="810" height="1" viewBox="0 0 810 1" fill="none" style="display: block; width: 100%;">
              <path d="M0 0.5H810" stroke="#B9C7CF"/>
            </svg>
          </div>
          <mapfre-alert
            *ngIf="showAlert"
            [closeButton]="true"
            [notTop]="false"
          ></mapfre-alert>
        </div>
      </ng-container>

      <div class="col second-col" *ngIf="showCompany==='all'">
        <p class="light-blue mb-3">{{ "Only available for Massachusetts policies" }}</p>
      </div>
      <div class="col" *ngIf="allLivoPolicies.length > 0" [ngClass]="{ 'paperless-padding': isAcmic, 'paperless-padding-ma':!isAcmic  }">
        <ng-container
          *ngFor="let pdetail of allLivoPolicies | sortByStatus : '-effDate'"
        >
          <div
            class="paperless-policy-display align-items-sm-center first row-your-policies paperless-policies"
            *ngIf="
              pdetail?.policyFlags.isEdfEligible.toUpperCase() === 'Y' &&
              !pdetail?.isNewPolicy &&
              pdetail?.policyStatus.toUpperCase() === 'ACTIVE'
            "
          >
            <div class="align-items-center d-flex" [ngClass]="{'w-100-mobile':isAcmic}">
              
              <div class="type-image" [ngClass]="{ 'auto-pay-icon': isAcmic, 'margin-right mr16':!isAcmic}">
                <img
                  src="{{pdetail?.displayType?.icon}}"
                  width="32" height="32" 
                  class="house-image"
                  alt="{{pdetail?.policyType?.toLowerCase()}} icon" 
                />
              </div>

              <div class="policy-type-id medium-font paperless-policy-display-id">
                <a class="autopay-paperless-policies"  [routerLink]="['/my-insurance', pdetail?.policynumber.policyNumber, 'details']" >
                  <span class="hide-policy-id-mobile">
                    {{ pdetail?.displayType?.label }} &ndash;
                  </span>
                  {{ pdetail?.policynumber.policyNumber }}
                </a>

                <span class="text-info-autopay-paperless margin-top mt-1"> 
                  {{ pdetail?.effDate | date:'MM/dd/yy' : 'shortDate' }}-{{ pdetail?.expDate | date:'MM/dd/yy' : 'shortDate' }}
                </span>
              </div>
            </div>

            <div class="enroll-button" [ngClass]="{'w-100-mobile paperless-mt acmic-hide-header':isAcmic}">
              <div
                class="pay-now-button" [ngClass]="{'enrollBTN':isAcmic, 'enrollBtn-paperless-pay-now': !isAcmic}"
                *ngIf="
                  pdetail?.policyFlags.isEdf === 'UNENROLLED' ||
                  pdetail?.policyFlags.isEdf === 'FALSE'
                "
              >
                <ng-container *ngIf="!(pdetail.jurisdiction.state === 'WA')">
                <mapfre-modal [modalOptions]="enrollOptionsModal" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()">
                  <div class="enroll-header" *ngIf="isAcmic">
                      <img src="assets/img/images/icon-close-paperless-acmic.svg" class="show-more-button" (click)="hideModalAction()"/>
                    </div>
                    <div class="modal-body enroll-modal-margin">
                      <div class="margin-bottom mb24 warning-icon-container">
                            <ng-container *ngIf="isAcmic; else maWarningIcon">
                            <img src="assets/img/images/icon-warning-enroll-paperless-acmic.svg"/>
                          </ng-container>
                          <ng-template #maWarningIcon>
                            <img src="assets/img/images/icon-warning-enroll-paperless-ma.svg"/>
                          </ng-template>
                      </div>
                      <div class="confirm-text">
                      <p class="confirm-text-sub-container">
                        {{ "CONFIRM_ENROLL_PAPERLESS" | translate }} {{ pdetail?.displayType?.label }} {{ "POLICY_PAPERLESS" | translate }} {{ pdetail?.policynumber.policyNumber }}
                      {{ "IN_PAPERLESS_ENROLL" | translate }}
                      </p>
                      </div>
                      
                      <hr class="paperless-hr" />
                      <div class="paperless-confirm no-padding">
                          <mapfre-button additionalClasses="paperless-confirm-btn ghost secondary large-btn paperless-modal-btns" (click)="hideModalAction()">
                          {{ "CANCEL" | translate }}
                          </mapfre-button>
                          <mapfre-button [ngClass]="{ custom_loader: loader }" additionalClasses="paperless-confirm-btn basic primary large-btn paperless-modal-btns" (click)="enroll(pdetail, 'e-policy')">
                            {{ "CONFIRM_CONTACT" | translate }}
                          </mapfre-button>
                      </div>
                    </div>
                  </mapfre-modal>
                </ng-container>

                <ng-container *ngIf="pdetail.jurisdiction.state === 'WA'">
                <a class="blue-text" [routerLink]="['/billing/paperless/'+ pdetail?.policynumber.policyNumber + '/enrollement']">
                  <mapfre-button additionalClasses="no-margin float-right primary ghost x-small-btn enroll-btn">
                      <span>{{ 'ENROLL' | translate }}</span>
              
                    </mapfre-button>
                  </a>
                </ng-container>
              </div>
              <div
                class="enroll-button cancelPaperless"
                *ngIf="
                  pdetail?.policyFlags.isEdf === 'ENROLLED' ||
                  pdetail?.policyFlags.isEdf === 'TRUE'
                "
              >
              
                <mapfre-button
                  (click)="onRemoveAccount(pdetail, 'e-policy')"
                  additionalClasses="btn mapfre policy-btn float-right ghost secondary x-small-btn enroll-btn"
                  [ngClass]="{
                    'unenroll-btn h40': !isAcmic,
                    'paperless-time-unenroll': isAcmic
                  }"
                >
                  {{ "UNENROLL" | translate }}
                </mapfre-button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="col" *ngIf="allAs400Policies.length > 0" [ngClass]="{'paperless-padding-ma':!isAcmic}">
        <ng-container *ngFor="let policy of allAs400Policies | sortByStatus: '-effDate';let i=index">
          <div class="align-items-sm-center row-your-policies paperless-policy-display nonGW-paperless-policy-display paperless-policies"
          [ngClass]="{ 'last': (allAs400Policies.length===i+1), 'first':!(allAs400Policies.length===i+1) }">
            <div class="align-items-sm-center paperless-policy-display">
              <div class="align-items-center d-flex">
                <div class="margin-right mr16 type-image">
                  <img
                    src="{{policy?.displayType?.icon}}"
                    width="32" height="32" 
                    class="house-image"
                    alt="{{policy?.policyType?.toLowerCase()}} icon" 
                  />
                </div>
                <div class="policy-type-id medium-font paperless-policy-display-id">
                  <a class="autopay-paperless-policies" [routerLink]="['/my-insurance', policy?.policynumber.policyNumber, 'details']" >
                    <span class="hide-policy-id-mobile">
                      {{ policy?.displayType?.label }} &ndash;
                    </span>
                    {{ policy?.policynumber.policyNumber }}
                  </a>
                  <span class="text-info-autopay-paperless margin-top mt-1">
                    {{ policy?.effDate | date:'MM/dd/yy' : 'shortDate' }}-{{ policy?.expDate | date:'MM/dd/yy' : 'shortDate' }}
                  </span>
                </div>
              </div>
              <div class=" ml-auto mt-3 mt-sm-0 enroll-button" *ngIf="policy?.policyFlags.isEdfEligible === 'Y'">
                <div
                  class="align-items-sm-center d-flex ml-auto"
                  [ngClass]="{
                    'justify-content-between ppr-right-col':
                      policy?.policyFlags.isEdfEligible === 'Y',
                    'justify-content-end':
                      policy?.policyFlags.isEdfEligible === 'N'
                  }"
                >
                  <div>
                    e-Policy
                  </div>
                  <div
                    class="text-right"
                    *ngIf="policy?.policyFlags.isEdfEligible === 'Y'"
                  >
                    <div
                      class="enroll-button ml-auto mt-3 mt-sm-0"
                      *ngIf="
                        policy?.policyFlags.isEdf === 'UNENROLLED' ||
                        policy?.policyFlags.isEdf === 'FALSE'
                      "
                    >
                      <mapfre-modal
                        *ngIf="policy?.days_left_to_expire > 30"
                        [modalOptions]="enrollOptionsModal"
                        [hideModal]="hideModal"
                        (hideModalOutput)="resetHideModal()"
                      >
                        <div class="modal-body">
                          <hr class="margin-bottom mb24 no-margin-top" />
                          <ng-container *ngIf="isAcmic; else maEditIcon">
                            <img src="assets/img/images/icon-edit-acmic-24.svg" alt="edit icon" />
                          </ng-container>
                          <ng-template #maEditIcon>
                            <svg-edit-icon-svg></svg-edit-icon-svg>
                          </ng-template>

                          <div class="" [ngClass]="{'margin-bottom mb24': !isAcmic,'center-align': isAcmic}">
                            {{
                              "PLEASE_CONFIRM_YOUR_REQUEST_TO_ENROLL_POLICY"
                                | translate
                            }}
                            <strong>{{
                              policy?.policynumber.policyNumber
                            }}</strong>
                            {{ "IN_PAPERLESS" | translate }}
                          </div>
                          <div class="mx-auto text-center">
                            <div>
                              <mapfre-button
                                [ngClass]="{ custom_loader: loader }"
                                additionalClasses="basic primary large-btn paperless-modal-btns"
                                (click)="enroll(policy, 'e-policy')"
                              >
                                {{
                                  "PAPERLESS_CONFIRM_BUTTON_TEXT" | translate
                                }}
                              </mapfre-button>
                            </div>
                            <div class="margin-top mt24">
                              <mapfre-button
                                additionalClasses="ghost secondary large-btn paperless-modal-btns"
                                (click)="hideModalAction()"
                              >
                                {{ "CANCEL" | translate }}
                              </mapfre-button>
                            </div>
                          </div>
                        </div>
                      </mapfre-modal>
                      <mapfre-button
                        *ngIf="policy?.days_left_to_expire <= 30"
                        additionalClasses="modal-medium enroll modal-dialog no-margin float-right primary ghost x-small-btn enroll-btn"
                        (click)="enroll(policy, 'e-policy')"
                      >
                        {{ "ENROLL" | translate }}
                      </mapfre-button>
                    </div>

                    <div
                      class="enroll-button cancelPaperless"
                      *ngIf="
                        policy?.policyFlags.isEdf === 'ENROLLED' ||
                        policy?.policyFlags.isEdf === 'TRUE'
                      "
                    >
                      <mapfre-button
                        (click)="onRemoveAccount(policy, 'e-policy')"
                        additionalClasses="btn mapfre policy-btn float-right ghost x-small-btn red-btn enroll-btn h40"
                        [ngClass]="{
                          'unenroll-btn': !isAcmic,
                          'paperless-time-unenroll': isAcmic
                        }"
                      >
                        {{ "UNENROLL" | translate }}
                      </mapfre-button>
                    </div>

                    <div
                      *ngIf="policy?.policyFlags.isEdf === 'ENROLLMENT-PENDING'"
                    >
                      <em>{{ "PENDING_ENROLLMENT" | translate }}</em>
                    </div>
                    <div
                      *ngIf="
                        policy?.policyFlags.isEdf === 'UNENROLLMENT-PENDING'
                      "
                    >
                      <em>{{ "PENDING_REMOVAL" | translate }}</em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="align-items-sm-center d-flex ml-auto"
              [ngClass]="{
                'justify-content-between':
                  policy?.policyFlags.isEbillEligible === 'Y',
                'justify-content-end':
                  policy?.policyFlags.isEbillEligible === 'N', 'ma-paperless-nonGW-container': !isAcmic
              }"
            >
              <div class="text-right" [ngClass]="{'ma-paperless-nonGW': !isAcmic}" *ngIf="policy?.policyFlags.isEbillEligible === 'Y'"
              >
                <div
                  class="enroll-button" [ngClass]="{'enrollBtn-paperless-pay-now': !isAcmic}"
                  *ngIf="
                    (policy?.policyFlags.isEbill === 'STATUS UNKNOWN' ||
                      policy?.policyFlags.isEbill === 'UNENROLLED' ||
                      policy?.policyFlags.isEbill === 'FALSE') &&
                    policy?.policyFlags.isEft !== 'ENROLLED'
                  "
                >
                  <mapfre-modal
                    [modalOptions]="enrollOptionsModal"
                    [hideModal]="hideModal"
                    (hideModalOutput)="resetHideModal()"
                  >
                    <ng-container *ngIf="isAcmic; else maEbil">
                      <div class="modal-body">
                        <hr class="margin-bottom mb24 no-margin-top" />
                        <div class="margin-bottom mb24">
                          {{
                          "PLEASE_CONFIRM_YOUR_REQUEST_TO_ENROLL_POLICY"
                              | translate
                          }}
                        <strong>{{ policy?.policynumber.policyNumber }}</strong>
                        {{ "IN_E-BILL" | translate }}
                        </div>
                        <div class="mx-auto text-center">
                          <div>
                            <mapfre-button
                              [ngClass]="{ custom_loader: loader }"
                              additionalClasses="basic primary large-btn paperless-modal-btns"
                              (click)="enroll(policy, 'e-bill')"
                            >
                            {{ "PAPERLESS_CONFIRM_BUTTON_TEXT" | translate }}
                            </mapfre-button>
                          </div>
                          <div class="margin-top mt24">
                            <mapfre-button
                              additionalClasses="ghost secondary large-btn paperless-modal-btns"
                              (click)="hideModalAction()"
                            >
                            {{ "CANCEL" | translate }}
                            </mapfre-button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #maEbil>
                      <div class="modal-body e-bill-unenroll">
                        <div class="margin-bottom mb24">
                        <img alt="warning icon" src="assets/img/images/icon-warning-enroll-paperless-ma.svg">
                        </div>
                        <div class="confirm-text">
                          <p class="confirm-text-sub-container">
                             {{ "CONFIRM_ENROLL_PAPERLESS" | translate }} {{ policy?.displayType?.label }} {{ "POLICY_PAPERLESS" | translate }} {{ policy?.policynumber?.policyNumber }}
                             {{ "E-BILL" | translate }}
                        </p>         
                        </div>
                        <hr class="paperless-hr" />
                            <div class="paperless-confirm no-padding">
                          <mapfre-button additionalClasses="paperless-confirm-btn ghost secondary large-btn paperless-modal-btns" (click)="hideModalAction()">
                          {{ "CANCEL" | translate }}
                          </mapfre-button>
                          <mapfre-button [ngClass]="{ custom_loader: loader }" additionalClasses="paperless-confirm-btn basic primary large-btn paperless-modal-btns" (click)="enroll(policy, 'e-bill')">
                            {{ "CONFIRM_CONTACT" | translate }}
                          </mapfre-button>
                      </div>                  
                      </div>
                    </ng-template>
                  </mapfre-modal>
                  
                  
                </div>
                <div
                  class="enroll-button cancelPaperless"
                  *ngIf="
                    policy?.policyFlags.isEbill === 'ENROLLED' ||
                    policy?.policyFlags.isEbill === 'TRUE'
                  "
                >
                  <mapfre-button
                    (click)="onRemoveAccount(policy, 'e-bill')"
                    additionalClasses="btn mapfre policy-btn float-right ghost x-small-btn red-btn enroll-btn h40"
                    [ngClass]="{
                      'unenroll-btn': !isAcmic,
                      'paperless-time-unenroll': isAcmic
                    }"
                  >
                    {{ "UNENROLL" | translate }}
                  </mapfre-button>
                </div>
                <div *ngIf="policy?.policyFlags.isEbill === 'UNENROLLMENT-PENDING'">
                  <em>{{ "PENDING_REMOVAL" | translate }}</em>
                </div>
                <div *ngIf="policy?.policyFlags.isEbill === 'ENROLLMENT-PENDING'">
                  <em>{{ "PENDING_ENROLLMENT" | translate }}</em>
                </div>
              </div>
              <div
                class="MsgpolNotElig"
                *ngIf="policy?.policyFlags.isEbillEligible === 'N'"
              >
                <div
                  *ngIf="
                    policy?.policyFlags.isEftEligible === 'Y' &&
                      (policy?.policyFlags.isEft === 'ENROLLED' ||
                        policy?.policyFlags.isEft === 'ENROLLMENT-PENDING') &&
                      (policy?.policyFlags.isEbill === 'STATUS UNKNOWN' ||
                        policy?.policyFlags.isEbill === 'UNENROLLED' ||
                        policy?.policyFlags.isEbill === 'FALSE');
                    else ebillNotAvailable
                  "
                >
                  <em>e-Bill {{ "EBILL_NOT_AVAILABLE" | translate }}</em>
                </div>
                <ng-template #ebillNotAvailable>
                  <em>{{ "NOT_ELEGIBLE_EBILL" | translate }}</em>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="isWAStatepolicy.length && isAcmic">
        <div class="col paperless-terms paperless-time-padding">
          <a
            [ngClass]="{
              'alignment margin-top mt-3 pr-15 paperless-terms-mobile':
                isAcmic
            }"
            [routerLink]="['/billing/paperless/enrollement']"
          >
            <span class="font-16 blue-link blue-link-terms-conditions">{{
              "PAPERLESS_TERMS_CONDITION" | translate
            }}</span>
          </a>
        </div>
      </ng-container>
      <div
        class="col mt-4"
        [ngClass]="{ 'paperless-padding no-margin-top': isAcmic, 'paperless-padding-ma':!isAcmic }"
      >
        <div>
          <h2 class="title margin-bottom mb-2 email-text padding-mobile-email email-mt">
            {{ "EMAIL_EBILL" | translate }}
          </h2>

            <div class="paperless-terms manage-email-paperless">
              <span class="user-email">{{ user }}</span>
                <span class="email-right text-info-autopay-paperless lh-18-imp">{{ 'MANAGE_EMAIL_TEXT' | translate }}<a class="blue-link lh-18-imp" [ngClass]="{'manage-details-link-ma': !isAcmic}" (click)="redirect_edit_email()">{{ 'CONTACT_DETAILS' | translate }}</a>.</span>
            </div>
        </div>
      </div>
    </div>
    <!-- row end -->
  </ng-container>

  <ng-container *ngIf="!checkForEligibility">
    <div class="text-center margin-vertical mv32">
      <img src="assets/img/images/not-eligible-paperless.png" width="360" alt="eligible paperless" />
      <h1 class="title margin-vertical mv16">
        {{ "NO_POLICY_IN_PAPERLESS" | translate }}
      </h1>
    </div>
    <div class="margin-top mt32 margin-bottom mb8">&nbsp;</div>
  </ng-container>
</ng-container>
<ng-container *ngIf="isAcmic; else backBtnMA" >
  <div
  class="row margin-top mt24 text-center checkingrowbtm"
  [ngClass]="{
    'no-margin-horizontal padding-left pl-0 mobile-back-margin': isAcmic
  }"
>
  <div class="col" [ngClass]="{ 'back-padding-mobile h-24 fs-16': isAcmic }">
    <mapfre-button
      (click)="goToMyAccount()"
      additionalClasses="h-24 link-button blue-color-link top-information no-padding font-weight-normal back-link"
      [backIcon]="'assets/img/images/icon-strong-arrow-left-paperless.svg'"
      [iconClasses]="'align-middle back-arrow-icon'"
      [showIconsCustom]="true"
    >
      {{ 'BACK' | translate }}
    </mapfre-button>
  </div>
</div>
</ng-container>
<ng-template #backBtnMA>
  <div class="row margin-top mt24 text-center checkingrowbtm h-24">
  <div class="col h-24">
    <mapfre-button
      (click)="goToMyAccount()"
      additionalClasses="h-24 link-button small-btn red-link no-margin button-border-red no-padding"
      [backIcon]="'./assets/img/icons/back-arrow-red.svg'"
      [iconClasses]="'align-middle pr-1'"
      [showIconsCustom]="true"
    >
<span class="fs-16">{{ "BACK" | translate }}</span>
    </mapfre-button>
  </div>
</div>
</ng-template>

